module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-layout', {
    staticClass: "form-layout"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("租赁申请单")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "slot": "apply-box",
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "inline": true
    },
    slot: "apply-box"
  }, [_c('el-form-item', {
    attrs: {
      "label": "发货类型",
      "prop": "DeliveryType"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "租赁代发／即时发货"
    },
    model: {
      value: (_vm.ruleForm.DeliveryType),
      callback: function($$v) {
        _vm.ruleForm.DeliveryType = $$v
      },
      expression: "ruleForm.DeliveryType"
    }
  }, _vm._l((_vm.DeliveryTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "OrderType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "固定租期／灵活租期"
    },
    on: {
      "change": _vm.orderTypeChange
    },
    model: {
      value: (_vm.ruleForm.OrderType),
      callback: function($$v) {
        _vm.ruleForm.OrderType = $$v
      },
      expression: "ruleForm.OrderType"
    }
  }, _vm._l((_vm.OrderTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户合同编号",
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "客户合同编号"
    },
    model: {
      value: (_vm.ruleForm.CustomerContractCode),
      callback: function($$v) {
        _vm.ruleForm.CustomerContractCode = $$v
      },
      expression: "ruleForm.CustomerContractCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人姓名",
      "prop": "ImmediateDeliveryContactName"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "联系人姓名"
    },
    model: {
      value: (_vm.ruleForm.ImmediateDeliveryContactName),
      callback: function($$v) {
        _vm.ruleForm.ImmediateDeliveryContactName = $$v
      },
      expression: "ruleForm.ImmediateDeliveryContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人电话",
      "prop": "ImmediateDeliveryContactPhone"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "联系人电话"
    },
    model: {
      value: (_vm.ruleForm.ImmediateDeliveryContactPhone),
      callback: function($$v) {
        _vm.ruleForm.ImmediateDeliveryContactPhone = $$v
      },
      expression: "ruleForm.ImmediateDeliveryContactPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "label": "联系地址",
      "type": "flex",
      "justify": "space-between",
      "prop": "ImmediateDeliveryAddress"
    }
  }, [_c('address-box', {
    attrs: {
      "province-id": _vm.ruleForm.ImmediateDeliveryProvinceId,
      "city-id": _vm.ruleForm.ImmediateDeliveryCityId,
      "county-id": _vm.ruleForm.ImmediateDeliveryCountyId,
      "address": _vm.ruleForm.ImmediateDeliveryAddress
    },
    on: {
      "update:provinceId": function($event) {
        _vm.ruleForm.ImmediateDeliveryProvinceId = $event
      },
      "update:cityId": function($event) {
        _vm.ruleForm.ImmediateDeliveryCityId = $event
      },
      "update:countyId": function($event) {
        _vm.ruleForm.ImmediateDeliveryCountyId = $event
      },
      "update:address": function($event) {
        _vm.ruleForm.ImmediateDeliveryAddress = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_area",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, _vm._l((_vm.leaseapplybox), function(item, index) {
    return _c('product-form', {
      key: index,
      ref: "initAmount",
      refInFor: true,
      attrs: {
        "product": item,
        "index": index,
        "orderType": _vm.ruleForm.OrderType,
        "delivery-type": _vm.ruleForm.DeliveryType
      },
      on: {
        "update:product": function($event) {
          item = $event
        },
        "delete": _vm.deleteItem
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "sumbit_box",
    attrs: {
      "slot": "sumbit_box"
    },
    slot: "sumbit_box"
  }, [_c('el-form', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.ruleForm.CustomerNotes),
      callback: function($$v) {
        _vm.ruleForm.CustomerNotes = $$v
      },
      expression: "ruleForm.CustomerNotes"
    }
  })], 1)], 1), _vm._v(" "), _c('p', [_vm._v("订单总租金："), _c('span', [_vm._v(_vm._s(_vm._f("amount")(_vm.totalAmount)))])]), _vm._v(" "), _c('p', [_vm._v("保修费用："), _c('span', [_vm._v(_vm._s(_vm._f("amount")(_vm.warrantyTotalAmount)))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v("订单总押金："), _c('span', [_vm._v(_vm._s(_vm._f("amount")(_vm.totalDeposit)))])]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.leaseapplybox.length === 0,
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("提交并等待客服联系")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    on: {
      "click": _vm.cencelBtn
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-422cbdc9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/LeaseApplyPage.vue
// module id = 730
// module chunks = 0